export default "__VITE_ASSET__D0yKvqjW__"